module.exports = __webpack_public_path__ + "img/undraw_predictive_analytics_kf9n.ce09c2d6.svg";